<template>
  <!-- 热血盲盒管理-盒子数据 -->
  <div class="battle_box_data-box">
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-input size="small" v-model="query.box_id" placeholder="盒子id"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input size="small" v-model="query.name" placeholder="盒子名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-date-picker v-model="query.start_time" type="datetime" placeholder="开始日期"
            value-format="yyyy-MM-dd HH:mm:ss" style="width: auto">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker v-model="query.end_time" type="datetime" placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
            style="width: auto">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-model="query.box_group_id" placeholder="请选择盒子分组" @change="getData(1)">
            <el-option :value="undefined">全部</el-option>
            <el-option v-for="item in boxGroupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData(1)">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </header>
    <p class="prompt">默认展示当天数据</p>
    <div class="body-box">
      <el-table :data="dataList" v-loading="loading">
        <el-table-column prop="box_id" label="箱子ID" width="100px" sortable="custom"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="price" label="盒子单价"></el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="{ row }">
            <el-tag type="primary" v-if="row.status === 1">正常</el-tag>
            <el-tag type="danger" v-if="row.status === 2">关闭</el-tag>
            <el-tag type="info" v-if="row.status === 3">补货中</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="draw_nums" label="抽奖次数" sortable="custom"></el-table-column>
        <el-table-column prop="draw_get_price" label="抽奖总额" sortable="custom"></el-table-column>
        <el-table-column prop="draw_out_price" label="奖品总额" sortable="custom"></el-table-column>
        <el-table-column prop="probability" label="概率">
          <template slot-scope="{ row }">
            <span>{{ (row.draw_out_price / row.draw_get_price).toFixed(4) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import http, {
  getData,
  postData,
  patchData,
  server,
  api,
  postApiData,
  patchApiData,
  getApiData
} from '@/http'
import saveFile from '@/utils/saveFile'


export default {
  data() {
    return {
      visible: false,
      loading: false,
      query: {
        page: undefined,
        name: undefined,
        box_id: undefined,
        start_time: undefined,
        end_time: undefined,
        box_group_id: undefined,
      },
      dataList: undefined,
      dataMeta: undefined,
    }
  },
  computed: {
    ...mapState({
      boxGroupList: state => state.data.boxGroupList,
    }),
  },
  created() {
    this.getData(1)
    this.getBoxGroupList({ category_id: 4 })
  },
  methods: {
    ...mapActions(['getCategories', 'getBoxGroupList']),
    getData(num) {
      if (num === 1) {
        this.query.page = 1
      }
      this.loading = true
      getApiData('mhb_lottery_statistics', {
        ...this.query
      })
        .then(res => {
          this.dataList = res
          // this.dataMeta = res.meta
        })
        .finally(() => {
          this.loading = false
        })
    },
    //导出
    handleExport() {
      let params = this.query

      http
        .post(
          api + 'mhb_box_sta_export',
          { ...params },
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '热血盲盒盒子数据.xlsx'
          })
        }).finally(() => {
        })
    },
  },
}

</script>

<style>

</style>
